import { render } from "./ToxicologyTestResults.vue?vue&type=template&id=65ae79ab"
import script from "./ToxicologyTestResults.vue?vue&type=script&lang=js"
export * from "./ToxicologyTestResults.vue?vue&type=script&lang=js"

import "./ToxicologyTestResults.vue?vue&type=style&index=0&id=65ae79ab&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/ToxicologyTestResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65ae79ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65ae79ab', __exports__)) {
    console.log('reload')
    api.reload('65ae79ab', __exports__)
  }
  
  module.hot.accept("./ToxicologyTestResults.vue?vue&type=template&id=65ae79ab", () => {
    console.log('re-render')
    api.rerender('65ae79ab', render)
  })

}


export default __exports__